/* eslint-disable */
import ReactQuill, { Quill } from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import { compose } from 'ramda'
import ImageResize from 'quill-image-resize-module-react'
import { useRef } from 'react'

// eslint-disable-next-line fp/no-unused-expression
Quill.register('modules/imageResize', ImageResize)

let useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      backgroundColor: 'white',
      color: 'black',
      '& .ql-editor': {
        backgroundColor: theme.palette.background.paper,
        color: 'white',
      },
    },
  }),
)

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
let Wysiwyg = ({ onChange, defaultValue = '', value = '' }) => {
  let classes = useStyles()
  let modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'], // toggled buttons
      ['blockquote', 'code-block'],

      [{ header: 1 }, { header: 2 }], // custom button values
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
      [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
      [{ direction: 'rtl' }], // text direction

      [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
      [{ header: [1, 2, 3, 4, 5, 6, false] }],

      [{ color: [] }, { background: [] }], // dropdown with defaults from theme
      [{ font: [] }],
      [{ align: [] }],
      ['link', 'image', 'video'],
      ['clean'],
    ],
    clipboard: {
      // toggle to add extra line breaks when pasting HTML:
      matchVisual: false,
    },
    imageResize: {
      parchment: Quill.import('parchment'),
      modules: ['Resize', 'DisplaySize', 'Toolbar'],
    },
  }

  return (
    <div className={classes.root}>
      {
        <ReactQuill
          value={decodeURI(value)}
          defaultValue={decodeURI(defaultValue)}
          theme="snow"
          onChange={compose(onChange, encodeURI)}
          modules={modules}
        />
      }
    </div>
  )
}

export default Wysiwyg
